module.exports = __webpack_public_path__ + "img/line-qrcode-th.db9ca16d.jpg";